import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
// import "./Assests/Scss/PerformanceEachStudent.scss";
import InternetChecking from "../../../Student/Reusablecomponents/Network";
import Loading from "../../../Student/Reusablecomponents/Loading";
import { FaAnglesLeft } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import {
  AssessmentName,
  SUbjects,
  Section,
} from "../../../Student/Reusablecomponents/RegularFunctions";
import { useSelector } from "react-redux";
import { ExportXlButton } from "../../../ReusableComponents/CommonComponents";
import { DownloadExcel } from "../../../ReusableComponents/CommonFunctions";
import DataTable from "../../../Student/Reusablecomponents/DataTable/DataTable";
import DropdownValues from "../../../Student/Reusablecomponents/DropDownValues";
import { InstituteGrades } from "../../../ReusableComponents/CommonApis";
const HQSPerformanceEachStudent = () => {
  const navigate = useNavigate();
  const [EachStudentData, SetEachStudentData] = useState([]);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const HQNDetails = JSON.parse(localStorage.getItem("HQNVLO"));
  const Filters = JSON.parse(localStorage.getItem("DiFFInput"));
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const [GetGrade, SetGetGrade] = useState(Filters?.Grade);
  const [GetSection, SetGetSection] = useState(Filters?.Section);
  const [GetSubject, SetGetSubject] = useState(Filters.Subject);
  const [Marks, SetMarks] = useState();
  const [Load, SetLoad] = useState(false);

  const GetEachStudentMarks = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/TeachersDashboard/GetStudentwiseMarksBySubject?ContestCreationId=${SelectDate?.value}&SubjectName=${GetSubject}&SchoolId=${Filters?.SchoolId}&Grade=${GetGrade}&Section=${GetSection}&AssessmentType=${SelectDate?.assessmentType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].studentName) {
          SetEachStudentData(res.data);
        } else {
          SetEachStudentData(process.env.REACT_APP_NODATAFOUND_Participated);
        }
      })
      .catch((err) => console.log(err));
  };

  const NavigatetoDifflevel = () => {
    const data = {
      Subject: GetSubject,
      Section: GetSection,
      Grade: GetGrade,
      SubjectsList: Filters?.SubjectsList,
      SectionsList: Filters?.SectionsList,
      SchoolId: Filters?.SchoolId,
    };
    localStorage.setItem("DiFFInput", JSON.stringify(data));
    // navigate("/Performance/SchoolPerformance/TeacherDiffLevel", { replace: true });
    window.close();
  };

  const GetSubjects = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/TeachersDashboard/GetSubjectsByGrade?ContestCreationId=${SelectDate?.value}&SchoolId=${Filters?.SchoolId}&Grade=${GetGrade}&AssessmentType=${SelectDate?.assessmentType}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0].subjectName) {
          const StoreSubjects = res.data.map((subject) => subject.subjectName);
          SetGetSubject(
            Filters?.Subject ||
            (StoreSubjects.includes(GetSubject) && GetSubject) ||
            StoreSubjects[0]
          );
          SetMarks(
            res.data.filter(
              (subject) =>
                subject.subjectName === Filters?.Subject ||
                (StoreSubjects.includes(GetSubject) && GetSubject) ||
                StoreSubjects[0]
            )[0]?.maxScore
          );
          GetEachStudentMarks();
          const data = {
            Section: GetSection,
            Grade: GetGrade,
            SubjectsList: Filters?.SubjectsList,
            SectionsList: Filters?.SectionsList,
            SchoolId: Filters?.SchoolId,
             HQUserId:Filters?.HQUserId,
          };
          localStorage.setItem("DiFFInput", JSON.stringify(data));
        } else {
          SetEachStudentData(process.env.REACT_APP_NODATAFOUND_Participated);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    if (SelectDate?.value) {
      GetSubjects();
    }else{
       SetEachStudentData(process.env.REACT_APP_NODATAFOUND_Participated);
    }
  }, [GetGrade, SelectDate?.value, GetSection, GetSubject]);
  const DownloadXl = () => {
    const XL = EachStudentData?.map((item, index) => {
      return {
        SNo: index + 1,
        Name: item.studentName,
        Score: item.marks,
        "Score %": `${item.marksPercentage}%`,
      };
    });
    DownloadExcel(
      XL,
      `Student wise performance - ${AssessmentName(
        SelectDate?.assessmentType
      )} - ${SelectDate?.examStartDate}`,
      false,
      `Student wise performance - ${AssessmentName(
        SelectDate?.assessmentType
      )} - ${SelectDate?.examStartDate}`,
      `Student wise performance - ${AssessmentName(
        SelectDate?.assessmentType
      )} - ${SelectDate?.examStartDate}`,
      true
    );
  };
  const columns = [
    { name: "Student Id", selector: "studentId" },
    { name: "Name", selector: "studentName" },
    { name: "Score", selector: "marks" },
    { name: "Score %", selector: "marksPercentage", cell: (row) => <div> {row.marksPercentage}%</div>, },
  ];
  const [ASSGrade, SetAssGrade] = useState();
  const GetAssmentdates = async () => {
    const Data = await InstituteGrades(items?.instituteId, SelectDate, USYear?.value, Filters?.HQUserId || items?.userId);
    const Grades = Data?.[0]?.grade?.split(",");
    SetAssGrade(
      Grades?.map((grade) => ({
        display: `Grade ${grade}`,
        value: grade.trim(),
      }))
    );
    SetGetGrade(Filters?.Grade || Grades?.[0]);
  };
  useMemo(() => {
    if (SelectDate) {
      GetAssmentdates();
    }
  }, [SelectDate]);
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
          {HQNDetails ?
          <b> <span >{HQNDetails?.Region?.RegionName ? <><span className="CPointer " onClick={() => navigate(-4)} style={{ color: "#696969" }}>{HQNDetails?.Region?.RegionName}</span> {""} &gt; {""} </> : ""}</span>
            <span className="CPointer " onClick={() => navigate(-3)} style={{ color: "#696969" }}>{HQNDetails?.State?.StateName || items?.societyName}</span> {""} &gt; {""}
            <span className="CPointer " onClick={() => navigate(-2)} style={{ color: "#696969" }}>{HQNDetails?.District?.DistrictName}</span>{""} &gt; {""}
            <span className="CPointer " style={{ color: "#696969" }} onClick={() => navigate(-1)}>{HQNDetails?.School?.SchoolName}</span>
          </b> : <div></div>}
        <div className="dflex JSBetween alignitems">
      
        <button className="Buttons" onClick={() => NavigatetoDifflevel()}>
          <FaAnglesLeft /> Performance by difficulty level{" "}
        </button>
       
        <div></div>
        <div></div>
        </div>
         <div className="MainHeading">
          Student wise performance -{" "}
          {AssessmentName(SelectDate?.assessmentType)} -{" "}
          {SelectDate?.examStartDate}
        </div>
        <div className=" dflex JSBetween alignitems mt-2">
          <div></div>
          <div className=" dflex alignitems" style={{ gap: "10px" }}>
            {SelectDate?.value > 0 && (
              <>
                <DropdownValues className="NCLDropdown" options={ASSGrade} selectoption={GetGrade} Displayname="Select Grade" onChange={(e) => SetGetGrade(e.target.value)} />
                {GetGrade > 0 && (
                  <>
                    <Section className="NCLDropdown" Postsection={SetGetSection} selected={"Section " + GetSection} Options={Filters?.SectionsList} />
                    {GetSection !== -1 && (
                      <SUbjects className="NCLDropdown" Postsubject={SetGetSubject} selected={GetSubject} Options={Filters?.SubjectsList} />
                    )}{" "}
                  </>
                )}{" "}
              </>
            )}

            <div style={{ fontSize: "15px", fontWeight: "bold" }}> Max Score : {Marks} </div>
            {EachStudentData?.[0]?.studentName && (<ExportXlButton Name="Export to Excel" Click={() => DownloadXl()} />)}
          </div>
        </div>

        <DataTable ShowPagination={true} Dropdownvalues={[10, 25, 50, 100]} className="NCLDataTable Card mt-2"
          ShowPagecount={true} columns={columns} data={EachStudentData} />
      </div>
      {Load && <Loading />}
    </>
  );
};
export default HQSPerformanceEachStudent;
